/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Typography, Dialog, Slide, CardActionArea, TextField,
} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import config from '../../../../../config';
import examType1Actions, { checkExamBeginTime } from '../../../../../redux/actions/examType1Actions';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '900px',
    alignSelf: 'center',
  },
  container: {
    marginTop: '100px',
    width: '100%',
    height: '100%',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '900px',
    gap: '30px',
  },
  getSubjectButton: {
    display: 'flex',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
    width: '270px',
    padding: 8,
  },
  textareaCard: {
    width: '100%',
    display: 'flex',
    height: '55%',
    flexDirection: 'column',
  },
  answerInfos: {
    maxWidth: '200px',
    padding: '8px',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    paddingLeft: '20px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  timerBox: {
    alignSelf: 'flex-end',
    padding: '10px 16px',
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    fontWeight: 500,
    fontSize: '15px',
    minWidth: 140,
    maxWidth: 210,
    width: '100%',
    textAlign: 'center',
  },
  textFieldContainer: {
    width: '100%',
    minWidth: 250,
    padding: '6px',
    borderRadius: 5,
    borderTopLeftRadius: 0,
    borderStyle: 'solid',
    backgroundColor: '#fff',
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  textField: {
    width: '100%',
    minWidth: 250,
    color: '#115',
    borderWidth: 1,
    backgroundColor: 'white',
  },
  sendButton: {
    display: 'flex',
    marginTop: '6px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
    width: '5%',
    minWidth: 100,
    paddingTop: 6,
    paddingBottom: 6,
  },
  modal: {
    padding: '20px',
    textAlign: 'center',
  },
  step: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
  },
  number: {
    fontSize: '12px',
    padding: '7px 13px',
    marginRight: '30px',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.main,
    borderRadius: '100%',
    color: theme.palette.primary.main,
  },
}));

const ExamType2 = ({ data, setExamBeginTime, additionalTime }) => {
  const [remainingTime, setRemainingTime] = useState(null);
  const classes = useStyles();

  const handleChange = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (!localStorage.getItem(`examBeginTime_${data.currentExam._id}`)) {
      setExamBeginTime(data.currentExam._id);
    }
  }, []);

  useEffect(() => {
    if (!data || !data.currentExam._id) return undefined;

    const examId = data.currentExam._id;
    const duration = data.currentExam.duration || 90;

    const updateTimer = () => {
      const remaining = checkExamBeginTime(additionalTime, duration, examId);
      setRemainingTime(remaining > 0 ? remaining : 0);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [data?.currentExam?._id, data?.currentExam?.duration, additionalTime]);

  const formatRemainingTime = (ms) => {
    if (ms == null || ms <= 0) return '00:00';

    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (value) => String(value).padStart(2, '0');

    if (hours > 0) {
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    return `${pad(minutes)}:${pad(seconds)}`;
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.timerBox}>
          Temps restant :
          {' '}
          {formatRemainingTime(remainingTime)}
        </div>
        {/* Section 1: Download exam */}
        <Typography component="h2" variant="h5">Download Exam</Typography>
        <div className={classes.step}>
          <Typography className={classes.number}>1</Typography>
          <CardActionArea
            component="a"
            href={`${config.OBJECT_URL}/exams/${data.examFile}`}
            target="_blank"
            className={classes.getSubjectButton}
            aria-label="Download your exam file"
          >
            <Typography variant="button">
              TELECHARGER LE SUJET D’EXAMEN
            </Typography>
          </CardActionArea>
        </div>

        {/* Section 2: Answer */}
        <Typography component="h2" variant="h5" style={{ marginTop: '20px' }}>Write Your Answer</Typography>
        <div className={classes.step}>
          <Typography className={classes.number}>2</Typography>
          <div className={classes.textareaCard}>
            <Typography className={classes.answerInfos} variant="button">
              {`${data.hiddenResults ? 'REPONSE ENVOYEE :' : 'REDACTION :'}`}
            </Typography>
            <div className={classes.textFieldContainer}>
              <TextField
                required
                multiline
                className={classes.textField}
                disabled={data.hiddenResults}
                variant="outlined"
                fullWidth
                size="small"
                maxRows={(window.innerHeight - 400) / 30}
                minRows={8}
                value={data.answer}
                onChange={data.handleAnswer}
                placeholder="Écrivez votre réponse ici.."
                helperText={data.hiddenResults ? `Sauvegardé à ${data.answerDate}` : null}
                onCut={handleChange}
                onCopy={handleChange}
                onPaste={handleChange}
                aria-label={data.hiddenResults ? 'Answer saved' : 'Write your answer here'}
                InputProps={{
                  inputProps: {
                    style: { resize: 'vertical' },
                  },
                }}
              />
              {
                !data.hiddenResults && (
                  <CardActionArea
                    onClick={() => data.handleApprovalAnswer()}
                    className={classes.sendButton}
                    aria-label="Send your answer"
                  >
                    <Typography variant="button">
                      ENVOYER
                    </Typography>
                  </CardActionArea>
                )
              }

              {/* Modal for approval */}
              <Dialog
                className={classes.modal}
                open={data.modalApproval}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => data.setModalApproval(false)}
                aria-labelledby="approval-dialog-title"
                aria-describedby="approval-dialog-description"
              >
                <DialogContent>
                  <DialogContentText id="approval-dialog-description">
                    {data.modalMessage}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => { data.setApproval(false); data.setModalApproval(false); }} aria-label="No">Non</Button>
                  <Button onClick={() => { data.setApproval(true); data.setModalApproval(false); }} aria-label="Yes">Oui</Button>
                </DialogActions>
              </Dialog>

              {/* Alert dialog */}
              <Dialog
                className={classes.modal}
                open={data.alertAnswer}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => data.setAlertAnswer(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {data.modalMessage}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => data.setAlertAnswer(false)} aria-label="Ok">Ok</Button>
                </DialogActions>
              </Dialog>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ExamType2.propTypes = {
  data: PropTypes.object,
  examFile: PropTypes.string,
  hiddenResults: PropTypes.bool,
  answer: PropTypes.string,
  handleAnswer: PropTypes.func,
  answerDate: PropTypes.instanceOf(Date),
  handleApprovalAnswer: PropTypes.func,
  modalApproval: PropTypes.bool,
  setModalApproval: PropTypes.bool,
  modalMessage: PropTypes.string,
  setApproval: PropTypes.bool,
  alertAnswer: PropTypes.bool,
  setAlertAnswer: PropTypes.bool,
  setExamBeginTime: PropTypes.func.isRequired,
};

ExamType2.defaultProps = {
  data: '',
  examFile: '',
  hiddenResults: '',
  answer: '',
  handleAnswer: '',
  answerDate: '',
  handleApprovalAnswer: '',
  modalApproval: '',
  setModalApproval: '',
  modalMessage: '',
  setApproval: '',
  alertAnswer: '',
  setAlertAnswer: '',
};
const actionCreators = {
  setExamBeginTime: examType1Actions.setExamBeginTime,
};

function mapState(state) {
  const { additionalTime } = state.user.userData;
  return {
    additionalTime,
  };
}
export default connect(mapState, actionCreators)(ExamType2);
